// Pagina recupero password
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { Link } from 'react-router-dom'
import { Mail, ArrowLeft } from 'lucide-react'
import { Input } from '../../components/ui/Input'
import { Button } from '../../components/ui/Button'
import { Alert } from '../../components/ui/Alert'
import api from '../../lib/api'

const schema = z.object({
  email: z.string().email('Inserisci un indirizzo email valido'),
})

type FormData = z.infer<typeof schema>

export function ForgotPasswordPage() {
  const [sent, setSent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const { register, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: zodResolver(schema),
  })

  const onSubmit = async (data: FormData) => {
    setIsLoading(true)
    setError(null)
    try {
      await api.post('/auth/forgot-password', { email: data.email })
      setSent(true)
    } catch {
      setError('Errore durante l\'invio. Riprova tra qualche minuto.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--fc-background)] p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--fc-primary)]">
            <Mail className="h-7 w-7 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[var(--fc-foreground)]">Recupera password</h1>
          <p className="mt-1 text-sm text-[var(--fc-foreground-muted)]">
            Inserisci la tua email per ricevere le istruzioni
          </p>
        </div>

        <div className="rounded-xl border border-[var(--fc-border)] bg-[var(--fc-surface)] p-6 shadow-[var(--fc-shadow-md)]">
          {sent ? (
            <Alert variant="success" title="Email inviata">
              Controlla la tua casella di posta. Le istruzioni per reimpostare la password sono state inviate.
            </Alert>
          ) : (
            <>
              {error && <Alert variant="error" className="mb-4">{error}</Alert>}
              <form onSubmit={handleSubmit(onSubmit)} noValidate className="space-y-4">
                <Input
                  label="Email"
                  type="email"
                  autoComplete="email"
                  leftIcon={<Mail className="h-4 w-4" />}
                  error={errors.email?.message}
                  required
                  {...register('email')}
                />
                <Button type="submit" className="w-full" isLoading={isLoading}>
                  Invia istruzioni
                </Button>
              </form>
            </>
          )}

          <Link
            to="/login"
            className="mt-4 flex items-center justify-center gap-1 text-sm text-[var(--fc-primary)] hover:underline"
          >
            <ArrowLeft className="h-4 w-4" />
            Torna al login
          </Link>
        </div>
      </div>
    </div>
  )
}
